import { render, staticRenderFns } from "./private-credit.vue?vue&type=template&id=6f3c3b5c&scoped=true"
import script from "./private-credit.vue?vue&type=script&lang=js"
export * from "./private-credit.vue?vue&type=script&lang=js"
import style0 from "./private-credit.vue?vue&type=style&index=0&id=6f3c3b5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3c3b5c",
  null
  
)

export default component.exports